import {createContext, useContext} from 'react'
import PropTypes from 'prop-types'
import {ResourceApiServiceProvider} from '../resource-api-service-provider'

const EmailVerificationTokensServiceContext = createContext(undefined)

const EmailVerificationTokensServiceProvider = ({
  children,
  oauthApiHost,
  handleUnauthorized = () => {
    // Do nothing
  }
}) => {
  return (
    <ResourceApiServiceProvider
      Context={EmailVerificationTokensServiceContext}
      handleUnauthorized={handleUnauthorized}
      host={oauthApiHost}
      valueCallback={(axios) => ({
        create: async (payload) => {
          const {data} = await axios.post(`/email_verification_tokens`, payload)
          return data
        }
      })}>
      {children}
    </ResourceApiServiceProvider>
  )
}

EmailVerificationTokensServiceProvider.propTypes = {
  children: PropTypes.any,
  oauthApiHost: PropTypes.string.isRequired,
  handleUnauthorized: PropTypes.func
}

const useEmailVerificationTokensService = () => {
  const context = useContext(EmailVerificationTokensServiceContext)
  if (context === undefined) {
    throw new Error('EmailVerificationTokensServiceContext was not provided. Make sure your component is a child of the EmailVerificationTokensServiceProvider.')
  }
  return context
}

export {EmailVerificationTokensServiceProvider, useEmailVerificationTokensService}
